import clsx from 'clsx';
import type { ReaderTag } from '@/api/client';
import { ReaderCatalogTagPill } from '@/components/ReadersTable/ReaderCatalogTagPill';

export function ReaderCatalogTagChips({
  tags,
  comfortable = false,
}: {
  tags: ReaderTag[] | undefined;
  /** Крупные бейджи (попап, справочник). */
  comfortable?: boolean;
}) {
  const list = tags ?? [];
  if (!list.length) {
    return <span className="projects-table__empty-value">—</span>;
  }
  const pillClass = comfortable ? 'reader-catalog-tag--comfortable' : undefined;
  return (
    <div
      className={clsx('readers-catalog-tag-chips', comfortable && 'readers-catalog-tag-chips_comfortable')}
      role="group"
      aria-label="Теги чтеца"
    >
      {list.map((t) => (
        <ReaderCatalogTagPill key={t.id} tag={t} className={pillClass} />
      ))}
    </div>
  );
}
